exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list-item.active-item[data-v-2201041e]{color:#2a3686!important}", ""]);

// exports
